export default __webpack_public_path__ + "static/media/add-plus-outline-16px-blue.daae9d44.svg";